import {createApp} from 'vue'
import Store from 'store'
import ServiceMenu from './ServiceMenu.options'

const component = createApp(ServiceMenu).use(Store)

const el = '.nlx-component--service-menu'
const DOM = document.querySelector(el)

if(DOM){
    const template = DOM.innerHTML
    const serviceMenuLinks = []

    DOM.querySelectorAll('.nlx-service-menu__link').forEach(link => {
        if(!link.dataset.cart && !link.dataset.login){
            serviceMenuLinks.push({
                href:link.querySelector('A').href,
                displayName:link.querySelector('A > .nlx-service-menu__link-label').innerText
            })
        }
    })

    Store.commit('main/set_service_menu_links',serviceMenuLinks)

    ServiceMenu.template = template
    DOM.classList.add(Store.state.main.user_logged_in_status ? 'nlx-service-menu--logged-in' : 'nlx-service-menu--logged-out')
    component.mount(el)
}

